export default __webpack_public_path__ + "static/blog-post-6-23fa97049b9bb973dce0903165a07d50.png";